import { c as _c } from "react/compiler-runtime";
import type { AgentInput } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import { useBuilder } from '../../store/provider';
import { useInputsSuggestions } from '../../store/suggestions';
import type { Suggestion } from '../../store/types';
import { inputsToWire } from '../../store/wire';
import InlineEditPair from './primitives/inline-edit-pair';
import PatchCard from './primitives/patch-card';
const InputsSuggestions = () => {
  const $ = _c(4);
  const suggestions = useInputsSuggestions();
  if (suggestions.length === 0) {
    return null;
  }
  let t0;
  if ($[0] !== suggestions) {
    t0 = suggestions.map(_temp);
    $[0] = suggestions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="flex flex-col gap-3">{t0}</div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
type Props = {
  suggestion: Suggestion;
};
type InputDiff = {
  added: AgentInput[];
  removed: AgentInput[];
  changed: {
    from: AgentInput;
    to: AgentInput;
  }[];
};
const diffInputs = (current: AgentInput[], next: AgentInput[]): InputDiff => {
  const currentByName = new Map(current.map(i => [i.fieldName, i]));
  const nextByName = new Map(next.map(i => [i.fieldName, i]));
  const added = next.filter(i => !currentByName.has(i.fieldName));
  const removed = current.filter(i => !nextByName.has(i.fieldName));
  const changed = next.flatMap(i => {
    const prev = currentByName.get(i.fieldName);
    if (!prev) return [];
    const differs = (prev.comment ?? '') !== (i.comment ?? '') || prev.isRequired !== i.isRequired;
    return differs ? [{
      from: prev,
      to: i
    }] : [];
  });
  return {
    added,
    removed,
    changed
  };
};
const InputsPatchCard = t0 => {
  const $ = _c(39);
  const {
    suggestion
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.suggestion.inputs"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const {
    state
  } = useBuilder();
  const op = suggestion.operation;
  if (op.kind !== "update_inputs") {
    return null;
  }
  let T0;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== op.inputs || $[2] !== state.bundle.inputs || $[3] !== suggestion.canApply || $[4] !== suggestion.id || $[5] !== t) {
    const {
      added,
      removed,
      changed
    } = diffInputs(inputsToWire(state.bundle.inputs), op.inputs);
    let t11;
    if ($[16] !== t) {
      t11 = input => `${input.comment || t(_temp2)} · ${input.isRequired ? t(_temp3) : t(_temp4)}`;
      $[16] = t;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    const describe = t11;
    T0 = PatchCard;
    t6 = suggestion.id;
    if ($[18] !== t) {
      t7 = t(_temp5);
      $[18] = t;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    t8 = !suggestion.canApply;
    if ($[20] !== t) {
      t9 = t(_temp6);
      $[20] = t;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    t10 = changed.length > 0;
    t2 = "flex flex-col gap-1";
    let t12;
    if ($[22] !== describe) {
      t12 = i => <div key={i.fieldName} className="text-caption-3 text-success"><span className="font-mono">+ {i.fieldName}</span><span className="text-tertiary"> — {describe(i)}</span></div>;
      $[22] = describe;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    t3 = added.map(t12);
    t4 = removed.map(_temp7);
    let t13;
    if ($[24] !== describe) {
      t13 = t14 => {
        const {
          from,
          to
        } = t14;
        return <InlineEditPair key={to.fieldName} label={to.fieldName} current={describe(from)} suggested={describe(to)} />;
      };
      $[24] = describe;
      $[25] = t13;
    } else {
      t13 = $[25];
    }
    t5 = changed.map(t13);
    $[1] = op.inputs;
    $[2] = state.bundle.inputs;
    $[3] = suggestion.canApply;
    $[4] = suggestion.id;
    $[5] = t;
    $[6] = T0;
    $[7] = t10;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    T0 = $[6];
    t10 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  let t11;
  if ($[26] !== t2 || $[27] !== t3 || $[28] !== t4 || $[29] !== t5) {
    t11 = <div className={t2}>{t3}{t4}{t5}</div>;
    $[26] = t2;
    $[27] = t3;
    $[28] = t4;
    $[29] = t5;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== T0 || $[32] !== t10 || $[33] !== t11 || $[34] !== t6 || $[35] !== t7 || $[36] !== t8 || $[37] !== t9) {
    t12 = <T0 suggestionId={t6} note={t7} isStale={t8} title={t9} showDiffToggle={t10}>{t11}</T0>;
    $[31] = T0;
    $[32] = t10;
    $[33] = t11;
    $[34] = t6;
    $[35] = t7;
    $[36] = t8;
    $[37] = t9;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  return t12;
};
export default InputsSuggestions;
function _temp(s) {
  return <InputsPatchCard key={s.id} suggestion={s} />;
}
function _temp2($) {
  return $.noNote;
}
function _temp3($_0) {
  return $_0.required;
}
function _temp4($_1) {
  return $_1.optional;
}
function _temp5($_2) {
  return $_2.refined;
}
function _temp6($_3) {
  return $_3.title;
}
function _temp7(i_0) {
  return <div key={i_0.fieldName} className="text-caption-3 text-error line-through decoration-error/60 font-mono!">- {i_0.fieldName}</div>;
}